import React, { Component } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect
} from 'react-router-dom';
import { StyleSheet, css } from 'aphrodite';
import async from 'async';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { AppTheme } from './styles/AppTheme';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { Controller } from './common/Controller';
import { ApiHelper } from './common/helpers/ApiHelper';
import { UiHelper } from './common/helpers/UiHelper';
import { Helper } from './common/helpers/Helper'
import { NoPermission } from './common/components/NoPermission';
import { NotFound } from './screens/NotFound';
import { Terms } from './screens/Terms';
import { Privacy } from './screens/Privacy';
import { Admin } from './screens/Admin';
import { Users } from './screens/Users';
import { OrgReports } from './screens/OrgEvents/OrgReports';
import { Places } from './screens/Places';
import { Place } from './screens/ClientPlace/Place';
import { Cams } from './screens/Cams';
import { Event } from './screens/ClientPlace/Event';
import { CamLive } from './screens/CamLive';
import { GuestUsers } from './screens/GuestUsersDetails/GuestUsers';
import { AppConfig } from './AppConfig';
import { Settings } from './screens/Settings';
import { CamLiveCloud } from './screens/CamLiveCloud';
import { LoginPage } from './screens/LoginPage';
import { Devices } from './screens/Devices';
import { PlaceSettings } from './screens/PlaceSettings';
import { CamSettings } from './screens/CamSettings';
import { Violations } from './screens/OrgEvents/Violations';
import Button from '@material-ui/core/Button';
const { v4: uuidv4 } = require('uuid');

let uuid = ""
const theme = createMuiTheme({
  palette: {
    primary: {
      main: AppTheme.primaryColor
    },
    secondary: {
      main: AppTheme.secondaryColor
    }
  },
  typography: {
    fontFamily: [
      'Quicksand',
      'sans-serif'
    ].join(',')
  }
});

const ProtectedRoute = (props) => {
  const user = Controller.get().userMgr().getloggedInUser();
  if (user) {
    if (props.appUser) {
      return props.checkPermsAndNavigate(props)
    }
    Controller.get().loginMgr().bootstrap((err, data) => {
      if (err) {
        console.error('bootstrap err:', err)
        Controller.get().userMgr().signOut()
        props.setAppUser();
        return
      }
      props.setAppUser();
    })
    return UiHelper.componentLoadingView()
  } else {
    // Controller.get().loginMgr().signOut()
    props.setAppUser(true);
    return <Redirect to='/login' />
  }
}

const PublicRoute = (props) => {
  const link = Controller.get().userMgr().getUserHome()
  if (Controller.get().userMgr().getloggedInUser()) {
    if (props && props.path === '/login') {
      return <Redirect to={link} />
    }
    // if (props && props.path === '/login/cm') {
    //   return <Redirect to={link} />
    // }
  }
  return <Route {...props} />
}

class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
      fetchState: ApiHelper.State.LOADING,
      appUser: null,
      showRegisterVMSAppBtn:false,
      vmsURL:''
    };
    this.intervalId = null;
    this.urlParams = new URLSearchParams(window.location.search);
    this.type = ""
    if(window.location.pathname.includes("cm")){
      this.type = "eecm"
    }else{
      this.type = "eevms"
    }
    this.refresh_token = this.urlParams ? this.urlParams.get('refresh_token') : undefined;
    this.code = this.urlParams ? this.urlParams.get('code') : undefined;
    this.access_token = this.urlParams ? this.urlParams.get('access_token') : undefined;
    this.uuid = this.urlParams ? this.urlParams.get('uuid') : undefined;
    if (this.uuid) {
      sessionStorage.setItem("uuid", this.uuid)
      window.location.replace(AppConfig.vmsLoginURL + AppConfig.eevmsLoginURL)
    }
    this.isIframe = false
    if (window.self !== window.top) {
      console.log("The URL is opened within an iframe.");
      this.isIframe = true
    } else {
      console.log("The URL is opened in the main browser window.");
      this.isIframe = false
    }
  }

  componentDidMount() {
    this.setup()
     uuid = uuidv4()

    this.setupUUID()
  }

  setupUUID(){
    sessionStorage.setItem("uuidv4", uuid)
    if (this.isIframe && !this.state.appUser) {
      this.startPullingCode(uuid)
    }
  }

  startPullingCode(uuidv4){

    this.intervalId = setInterval(() => {
     this.pullCode(uuidv4);
      if (this.code) {
        console.log('Code received:', this.code);
        clearInterval(this.intervalId);
        this.setup()
        // sessionStorage.removeItem("uuidv4");
      }
    }, 1000); 
  }
    


  pullCode(uuidv4) {
    if (this.state.appUser) {
      console.log('Code received:', this.code);
      clearInterval(this.intervalId);
      return
     }
    let query = {uuid : uuidv4, pullCode:true}
  
    async.parallel(
      [
         (callback) => {
          ApiHelper.publicApiCall(
            { method: 'GET', endPoint: ApiHelper.makeUrlPath(['miscs', 'pullCode'], query) }, (err,d)=>{
              return callback(err,d)
            })
        }
      ],
      function (err, results) {
        if (err) {
          // this.setState({
          //   fetchState: ApiHelper.State.ERROR,
          //   errMsg: Helper.getErrorMsg(err)
          // })
          return
        }
        const data = results[0];
        this.code = data.code
      }.bind(this))
  }

  setup() {
    let query = {}
    if(this.access_token){
      query['access_token'] = this.access_token
    }

    if(this.type){
      query['type'] = this.type
    }
    if(this.refresh_token){
      query['refresh_token'] = this.refresh_token
    }else if(this.code){
      query['code'] = this.code
    }else{
      query=undefined
    }

    if(
      query &&
      localStorage.getItem("vmsClientId")
    ){
      query['clientId'] = localStorage.getItem("vmsClientId")
    }

    if (query &&
      sessionStorage.getItem("uuid")
    ) {
      query['uuid'] = sessionStorage.getItem("uuid")
    }

    async.parallel(
      [
         (callback) => {
          ApiHelper.publicApiCall(
            { method: 'GET', endPoint: ApiHelper.makeUrlPath(['miscs', 'setup'], query) }, (err,d)=>{
              return callback(err,d)
            })
        }
      ],
      function (err, results) {
        if (err) {
          this.setState({
            fetchState:  ApiHelper.State.ERROR,
            errMsg: Helper.getErrorMsg(err)
          })
          if(sessionStorage.getItem("uuidv4")){
            sessionStorage.removeItem("uuidv4")
          }
          if(sessionStorage.getItem("uuid")){
            sessionStorage.removeItem("uuid")
          }
          return
        }
        const data = results[0];
        if (data) {
          if (data.allowLocal === true) {
            AppConfig.allowLocal = data.allowLocal
          }
          if (data.autoUpdateEvent !== undefined) {
            AppConfig.autoUpdateEvent = data.autoUpdateEvent
          }
          if (data.NAME !== undefined) {
            AppConfig.NAME = data.NAME
          }
          if (data.placeTypes !== undefined) {
            AppConfig.placeTypes = data.placeTypes
          }
          if (data.camTypes !== undefined) {
            AppConfig.camTypes = data.camTypes
          }
          if (data.orgTypes !== undefined) {
            AppConfig.orgTypes = data.orgTypes
          }
          if (data.DEFAULT_FIELDS !== undefined) {
            AppConfig.DEFAULT_FIELDS = data.DEFAULT_FIELDS
          }
          if (data.SHOW_DEVICES_INFO !== undefined) {
            AppConfig.SHOW_DEVICES_INFO = data.SHOW_DEVICES_INFO
          }
          if (data.DEVICE_HEALTH_CHECK_DURATION_SECONDS !== undefined) {
            AppConfig.DEVICE_HEALTH_CHECK_DURATION_SECONDS = data.DEVICE_HEALTH_CHECK_DURATION_SECONDS
          }
          if (data.ES_EVENT_TYPES !== undefined) {
            AppConfig.ES_EVENT_TYPES = data.ES_EVENT_TYPES
          }
          if(data.email){
            if(data.clientId){
              localStorage.setItem("vmsClientId", data.clientId)
              this.setState({
                showRegisterVMSAppBtn :true,
                vmsURL: `https://auth.eagleeyenetworks.com/oauth2/authorize?scope=vms.all&client_id=${data.clientId}&response_type=code&redirect_uri=${AppConfig.eevmsLoginURL}`
              })
              return
            }else{
              localStorage.removeItem("vmsClientId")
              this.setState({
                showRegisterVMSAppBtn :false,
                vmsURL: null
              })
            }
            this.setState({
            fetchState:this.uuid ? ApiHelper.State.LOADING : ApiHelper.State.READY,
            },()=>{
            localStorage.clear();
            let res = {
              state: {
                type: 'cameramanager',
                email: data.email,
                pword:data.pword
              }
            }
            Controller.get().pushRouteWithQueryParams("/login",'',res);
            if(sessionStorage.getItem("uuidv4")){
              window.location.reload()
              sessionStorage.removeItem("uuidv4")
            }
          })

          }else{
          this.setState({
            fetchState:this.uuid ? ApiHelper.State.LOADING : ApiHelper.State.READY,
          });
        }
        }
      }.bind(this))
  }

  checkPermsAndNavigate = (path, props) => {
    if (Controller.get().userMgr().checkUserPermission(path, props.computedMatch)) {
      if (path === '/') {
        return <Redirect to={Controller.get().userMgr().getUserHome()} />
      } else {
        return <Route {...props} />
      }
    } else {
      return UiHelper.getErrorMsg()
    }
  }

  setAppUser = (isLoggedOut) => {
    this.setState({
      appUser: isLoggedOut ? null : Controller.get().userMgr().getUser(),
    })
  }

  getProtectedRoute(path, component) {
    return (
      <ProtectedRoute
        setAppUser={this.setAppUser}
        appUser={this.state.appUser}
        checkPermsAndNavigate={(props) => this.checkPermsAndNavigate(path, props)}
        exact
        path={path}
        component={component}
      />
    );
  }

  render() {
    if (this.state.showRegisterVMSAppBtn) {
      return (<>
      <div  className={css(Styles.container)}>
        <div style={{display:"block", marginBottom:"20px"}}>To proceed, no application has been found. You must register the application before continuing. Please click the "Register App" button below and log in again.</div>
        <Button
          variant='contained'
          onClick={() => {

            window.location.href = this.state.vmsURL

          }}
          className={css(Styles.actionButton)}>
          Register APP
        </Button></div>
      </>)
    }
    if (this.state.fetchState === ApiHelper.State.LOADING) {
      return UiHelper.componentLoadingView();
    } else if (this.state.fetchState === ApiHelper.State.ERROR) {
      return UiHelper.errorView(this);
    } else {
      return this.readyView();
    }
  }

  readyView() {
    return (
      <Router>
        <MuiThemeProvider theme={theme}>
          <Route path={'/'} component={({ location, history }) => {
            return (
              <div className={css(Styles.page)}>
                {this.state.appUser && Controller.get().loginMgr().getCurrentUser() &&
                  <Header
                    path={history.location.pathname}
                    className={css(Styles.header)}
                    currentUser={this.state.appUser}
                    onDashboardClick={() => this.onDashboardClick()}
                    onLogoutClick={() => this.onLogoutClick()} />
                }

                <div className={css(Styles.content)}>
                  {this.renderRoute(history)}
                </div>

                <Footer className={css(Styles.footer)} />

              </div>
            )
          }} />
        </MuiThemeProvider>
      </Router>
    );
  }

  renderRoute(history) {
    Controller.get().setNavigator(history);
    return (
      <Switch>
        <PublicRoute exact path={'/login'} component={LoginPage} />
        {/* <PublicRoute exact path={'/login/cm'} component={LoginPage} /> */}

        <PublicRoute exact path={'/terms'} component={Terms} />
        <PublicRoute exact path={'/privacy'} component={Privacy} />
        <PublicRoute exact path={'/no-permission'} component={NoPermission} />

        {this.getProtectedRoute('/')}

        {this.getProtectedRoute('/orgs', Admin)}
        {this.getProtectedRoute('/orgs/:id', Users)}
        {this.getProtectedRoute('/orgs/:id/places', Places)}
        {this.getProtectedRoute('/orgs/:id/users', Users)}
        {this.getProtectedRoute('/orgs/:id/devices', Devices)}
        
        {window.localStorage.currentOrg && JSON.parse(window.localStorage.currentOrg) && JSON.parse(window.localStorage.currentOrg).type == "society" ? this.getProtectedRoute('/orgs/:id/guests', GuestUsers) :""}
        {this.getProtectedRoute('/orgs/:id/reports', OrgReports)}
        {this.getProtectedRoute('/orgs/:id/violations', Violations)}
        {this.getProtectedRoute('/orgs/:id/settings', Settings)}
        {this.getProtectedRoute('/orgs/:id/places/:placeid/settings', PlaceSettings)}
        {AppConfig.SHOW_DIRECT_LINK_EVENT &&
          this.getProtectedRoute('/orgs/:id/allEvents', Cams)
        }
        {this.getProtectedRoute('/places/:id', Place)}
        {this.getProtectedRoute('/places/:id/cams', Cams)}
        {AppConfig.allowLocal &&
          this.getProtectedRoute('/places/:id/cams/:camid', CamLive)
        }
        {!AppConfig.allowLocal &&
          this.getProtectedRoute('/places/:id/cams/:camid', CamLiveCloud)
        }

        {this.getProtectedRoute('/places/:id/cams/:camid/settings', CamSettings)}

        {this.getProtectedRoute('/events/:eventId', Event)}


        <Route component={NotFound} />
      </Switch>
    )
  }

  onLogoutClick() {
    if (AppConfig.allowLocal) {
      Controller.get().loginMgr().localSignout()
      Controller.get().userMgr().signOut()
    } else {
      Controller.get().logout()
    }
    this.setState({
      appUser: null
    }, ()=>{
      if (this.isIframe && !this.state.appUser) {
        this.setupUUID()
      }
    })
  }

  onDashboardClick() {
    this.props.history.push('/orgs');
  }
}

const Styles = StyleSheet.create({
  page: {
  },
  header: {
    flex: '0 0 auto',
    position:"fixed !important"
  },
  content: {
    display: 'flex',
    justifyContent: 'center',
    minHeight: '97.4vh',
    backgroundColor:"rgb(238, 238, 238) !important"
  },
  footer: {
    flex: '0 0 auto',
    display:AppTheme.displayFooter
  },
  container: {
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    alignContent: 'center',
    backgroundSize: 'cover',
    minHeight: '100vh',
    flexDirection:'column'
  }
})

export default App;
